import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import Moment from 'react-moment';
import Pagination from  '../../../../components/Pagination/Pagination';
import Spinner from 'react-bootstrap/Spinner';
import '../../../../styles/ops-list.css';
import './AssetTasks.css';

import { ITEMS_PER_PAGE } from '../../../../localdb';
import { useI18n } from '../../../../i18n';

const AssetTasks = (props) => {
	const { t } = useI18n();
	const [tasks, setTasks] = useState([]);
	const [users, setUsers] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(ITEMS_PER_PAGE);
    const params = {
        headers: {
			'x-api-key': process.env.REACT_APP_API_KEY,
			'Accept': 'application/json',
			'Content-Type': 'application/json',
        },
    }

    const getUsers = async () => {
        await API.get('users','/', params)
        .then(res => {
            let userList = [];
            res.Users.forEach((item) => {
                let user = {}
                user.id = item.Username;
                item.Attributes.forEach((e) => {
                    if (e.Name === 'name')
                        user.name = e.Value;
                })
                userList.push(user);
            })
            setUsers(userList);
        });
    }

    useEffect(()=>{
        const loadUsers = async () => {
            await getUsers();
        }

        if (props.users) {
            setUsers(props.users);
        } else {
            loadUsers();
        }
    }, [props.users]);

    useEffect(()=>{
		setIsLoading(true);
		API.get('task_by_asset','/' + props.assetId, params)
		.then(list => {
			setTasks(list || []);
			setIsLoading(false);
		}).catch(() => {
			setIsLoading(false);
		});

	}, []);

	const statusClass = (status) => {
		switch (status) {
			case 'Created': return 'task_created';
			case 'Accepted': return 'task_accepted';
			case 'Started': return 'task_started';
			case 'Completed': return 'task_completed';
			case 'WIP': return 'task_wip';
			default: return 'taskStatus';
		}
	};

	const engineerName = (item) => {
		const id = item.user_completed || item.user_accepted;
		if (!id) return '';
		const match = users.find((usr) => usr.id === id);
		return match ? match.name : '';
	};

	const sortedTasks = [...tasks].sort((a, b) => (a.date_created > b.date_created) ? -1 : 1);
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const currentItemList = sortedTasks.slice(indexOfFirstItem, indexOfLastItem);

	const paginate = pageNumber => setCurrentPage(pageNumber);

	const snippet = (text) => {
		if (!text) return '';
		return text.length > 140 ? text.substring(0, 140) + '…' : text;
	};

	return (
	<div className="AssetTasks task-ops">
			{isLoading ? (
			<div className="loading-content">
				<Spinner animation="border" role="status" className="loading-spinner" />
				<div className="loading-text">{t('tasks.loading')}</div>
			</div>
			) : currentItemList.length === 0 ? (
				<div className="task-ops-empty">{t('assets.noTasks')}</div>
			) : (
			<div>
				<div className="panel-kicker">{tasks.length} {tasks.length === 1 ? t('common.task') : t('common.tasks')}</div>
				<div className="task-ops-panel">
				{currentItemList.map((item) => (
					<article
						key={item.taskId}
						className="task-ops-item"
						onClick={() => props.history.push('/task_det/'+ item.taskId )}
					>
						<div className="task-ops-row">
							<div className="task-ops-identity">
								<Link
									className="task-ops-id"
									to={`/task_det/${item.taskId}`}
									onClick={(e) => e.stopPropagation()}
								>
									#{item.task_ref}
								</Link>
								{item.task_status && (
									<span className={`task-ops-status ${statusClass(item.task_status)}`}>{item.task_status}</span>
								)}
								{item.date_created && (
									<span className="task-ops-date">
										<Moment local format='DD MMM YYYY' date={item.date_created} />
									</span>
								)}
							</div>
							<p className="task-ops-title" title={item.fault_description}>
								{snippet(item.fault_description) || 'No description'}
							</p>
							<div className="task-ops-meta">
								<div className="task-ops-place">
									{item.category && <span className="task-ops-site-code">{item.category}</span>}
									{engineerName(item) && <span className="task-ops-cat">· {engineerName(item)}</span>}
									{item.work_completed && <span className="task-ops-site-name" title={item.work_completed}>· {snippet(item.work_completed)}</span>}
								</div>
								{item.date_completed && (
									<span className="task-ops-date">
										Completed <Moment local format='DD MMM YYYY' date={item.date_completed} />
									</span>
								)}
							</div>
						</div>
					</article>
				))}
				</div>

				{tasks.length > itemsPerPage && (
				<Pagination
					sizePerPage={itemsPerPage}
					currentPage={currentPage}
					totalSize={tasks.length}
					changeCurrentPage={paginate}
					theme="bootstrap"
				/>
				)}
			</div>
			)}
	</div>);
}

export default ( AssetTasks);
